import {
    setState,
} from '~shared/utils/state';

import {
    USER_LOCALE_STATE_KEY,
    USER_COUNTRY_ISO_STATE_KEY,
    USER_COUNTRYSTATE_STATE_KEY,
    USER_TIMEZONE_STATE_KEY,
    USER_CURRENCY_ISO_STATE_KEY,
    USER_LANGUAGE_ISO_STATE_KEY,
    BRAND_ID_STATE_KEY,
    SUB_BRAND_ID_STATE_KEY,
    PRODUCT_PACKAGE_ID_STATE_KEY,
    REGULATION_TYPE_ID_STATE_KEY,
    USER_HAS_KAMBI_BETS,
    USER_MODE_STATE_KEY,
    USER_DEVICE_STATE_KEY,
    WRAPPER_IS_MOBILE_STATE_KEY,
    WRAPPER_IS_HYBRID_STATE_KEY,
    WRAPPER_IS_FTD_STATE_KEY,
    WRAPPER_IS_PROMOTION_PERMITTED_STATE_KEY,
    WRAPPER_IS_PROMOTION_RESTRICTED_STATE_KEY,
    WRAPPER_IS_VIP_STATE_KEY,
    WRAPPER_RMS_STATE_KEY,
    WRAPPER_SERIAL_STATE_KEY,
    WRAPPER_OS_NAME,
    WRAPPER_OS_VERSION,
    WRAPPER_PAGE_CORRELATION_ID_STATE_KEY,
    USER_THEME_MODE_STATE_KEY,
} from '~shared/utils/user';

const CLIENT_STETTING_OVERWRITE_PREFIX = 'spectate:overwrite:ClientSettings:';

/*
+-------------------+--------------------+------------------------------+
|        888        |      Spectate      |         Client State         |
+-------------------+--------------------+------------------------------+
| brandID           | brand_id           | BRAND_ID_STATE_KEY           |
| subBrandID        | sub_brand_id       | SUB_BRAND_ID_STATE_KEY       |
| productPackageID  | product_package_id | PRODUCT_PACKAGE_ID_STATE_KEY |
| languageCode      | language           | USER_LANGUAGE_ISO_STATE_KEY  |
| country           | country            | USER_COUNTRY_ISO_STATE_KEY   |
| currency          | currency_code      | USER_CURRENCY_ISO_STATE_KEY  |
| regulationTypeID  | regulation_type_id | REGULATION_TYPE_ID_STATE_KEY |
| timeZoneUTCOffset | timezone           | USER_TIMEZONE_STATE_KEY      |
| userMode          | user_mode          | USER_MODE_STATE_KEY          |
| themeMode         | themeMode          | USER_THEME_MODE_STATE_KEY    |
+-------------------+--------------------+------------------------------+
*/

const clientSettingsStateKeys = {
    brand_id: BRAND_ID_STATE_KEY,
    sub_brand_id: SUB_BRAND_ID_STATE_KEY,
    product_package_id: PRODUCT_PACKAGE_ID_STATE_KEY,
    language: USER_LANGUAGE_ISO_STATE_KEY,
    country: USER_COUNTRY_ISO_STATE_KEY,
    country_state: USER_COUNTRYSTATE_STATE_KEY,
    currency_code: USER_CURRENCY_ISO_STATE_KEY,
    locale: USER_LOCALE_STATE_KEY,
    regulation_type_id: REGULATION_TYPE_ID_STATE_KEY,
    timezone: USER_TIMEZONE_STATE_KEY,
    user_mode: USER_MODE_STATE_KEY,
    deviceTypeID: USER_DEVICE_STATE_KEY,
    is_mobile: WRAPPER_IS_MOBILE_STATE_KEY,
    is_hybrid: WRAPPER_IS_HYBRID_STATE_KEY,
    is_ftd: WRAPPER_IS_FTD_STATE_KEY,
    is_promotion_permitted: WRAPPER_IS_PROMOTION_PERMITTED_STATE_KEY,
    is_promotion_restricted: WRAPPER_IS_PROMOTION_RESTRICTED_STATE_KEY,
    is_vip: WRAPPER_IS_VIP_STATE_KEY,
    rms: WRAPPER_RMS_STATE_KEY,
    serial: WRAPPER_SERIAL_STATE_KEY,
    has_kambi_bets: USER_HAS_KAMBI_BETS,
    osName: WRAPPER_OS_NAME,
    osVersion: WRAPPER_OS_VERSION,
    themeMode: USER_THEME_MODE_STATE_KEY,
    page_correlation_id: WRAPPER_PAGE_CORRELATION_ID_STATE_KEY,
};

const map888paramsToSpectate = {
    brandID: 'brand_id',
    subBrandID: 'sub_brand_id',
    productPackageID: 'product_package_id',
    languageCode: 'language',
    country: 'country',
    currency: 'currency_code',
    locale: 'locale',
    regulationTypeID: 'regulation_type_id',
    timeZoneUTCOffset: 'timezone',
    userMode: 'user_mode',
    isMobile: 'is_mobile',
    isHybrid: 'is_hybrid',
    isFTD: 'is_ftd',
    isPromotionPermitted: 'is_promotion_permitted',
    isPromotionRestricted: 'is_promotion_restricted',
    isVIP: 'is_vip',
    RMS: 'rms',
    serial: 'serial',
    state: 'country_state',
    HasKambiBets: 'has_kambi_bets',
    osName: 'osName',
    osVersion: 'osVersion',
    pageCorrelationId: 'page_correlation_id',
    themeMode: 'themeMode',
};

// eslint-disable-next-line no-console
const catchError = (msg) => console.error(msg);

const normalizeParamName = (param) => {
    let paramName = param;
    if (map888paramsToSpectate.hasOwnProperty(param)) {
        paramName = map888paramsToSpectate[param];
    }

    return paramName;
};

const getStateKeyForParam = (param) => {
    let internalParamName = normalizeParamName(param);

    if (!clientSettingsStateKeys.hasOwnProperty(internalParamName)) {
        catchError(`Given param [${internalParamName} (${param})] is not allowed`);

        return undefined;
    }

    return clientSettingsStateKeys[internalParamName];
};

/**
 * This method allows developers and QA to overwrite some settings
 * which come from Wrapper.
 *
 * For example:
 *     sessionStorage.setItem('spectate:overwrite:ClientSettings:language', 'eng')
 *
 * @param {String} param            Client setting spectate param name (normalized)
 * @param {String|Integer} value    Client setting value
 *
 * @return {String|Integer}         Returns value whether is has been overwritten
 *                                  or not
 */
const overwriteClientSetting = (param, value) => {
    const key = `${CLIENT_STETTING_OVERWRITE_PREFIX}${param}`;
    const overwrittenValue = sessionStorage.getItem(key);
    if (overwrittenValue !== null) {
        return overwrittenValue;
    }

    return value;
};

const storeInState = (param, value) => {
    const stateKey = getStateKeyForParam(param);
    if (stateKey === undefined) {
        return;
    }

    setState(
        stateKey,
        overwriteClientSetting(normalizeParamName(param), value)
    );
};

export const processClientSettings = (clientSettings) => {
    Object.entries(clientSettings).forEach(
        ([param, value]) => storeInState(param, value)
    );
};
